import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import {useFetch} from '../hooks/useFetch';

export default ({onChange, name, value, label,  ...props}) => {
    const {data, isLoading} = useFetch('/product');

    const options = data?.map(item => ({label: item.name, id: item.id})) || [];

    const handleChange = (e, data) => {
        onChange(name, data?.id || '');
    };
    return (
        <>
            <Autocomplete
                options={options}
                onChange={handleChange}
                value={options.filter(item => item.id === value)[0] || null}
                isOptionEqualToValue={props => props.id === value}
                loading={isLoading}
                id="select-customer"
                fullWidth
                renderInput={params => <TextField {...params} label={label? label: 'Produto'} />}
            />
        </>
    );
};
